<!-- header area start -->
<div class="row">

  <!-- menu button, location and client selectors -->
  <div class="col-sm-3 header-left clearfix">
    <div id="navbtn" class="nav-btn pull-left" (click)="toggleSidebar()">
      <button title="{{'_Shared_App_State_Sidebar_Text_' | translate }}"><img src="assets/images/icon/hamburger%20menu.svg" alt=""></button>
    </div>


    <div ngbDropdown class="tenant-select-btn" (mouseenter)="mouseEnter()">
      <button [disabled]="!(userPermissionList.includes(26)) || availableTenants.length <= 1"
        [ngClass]="{'disabled': !(userPermissionList.includes(26)) || availableTenants.length <= 1}"
        (click)="showTenantChange()" title={{clientToolTip}}>{{selectedTenant.tenantDisplayName}}</button>
    </div>

    <div class="tenant-select-btn"
        *ngIf="(isACLicenseEnabled$ | async) && isDefaultPermissionGroup">
      <button (click)="goToAC()" id="ukg-ac-appointments" title="Click here to open FMSI Appointments">
        <div class="left-nav-item">
          <em class="cc-nav-icon fa-solid fa-calendar-days"></em>
        </div>
      </button>
    </div>

    <div class="tenant-select-btn sync" *ngIf="(isACLicenseEnabled$ | async) && syncEnabled && userPermissionList.includes(26)">
      <button [disabled]="syncInProgress" (click)="openSyncPopup()" class="sync-content space-x" [ngClass]="{'disabled': syncInProgress}" 
      [title]="syncInProgress ? syncInProgressMessage  : manualSyncMessage" >
        <div *ngIf="syncInProgress" class="lds-dual-ring"></div>
        <span *ngIf="!syncInProgress">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.7488 11.398C11.9215 11.6208 11.0968 11.8504 10.2681 12.065C9.62143 12.2335 9.1405 12.0175 8.99377 11.5135C8.85656 11.042 9.21386 10.5285 9.81163 10.36C11.283 9.94567 12.7543 9.53674 14.227 9.12917C14.7147 8.99468 15.3111 9.39817 15.3491 9.94975C15.4592 11.5148 15.5434 13.0826 15.6127 14.6504C15.6344 15.1408 15.254 15.5171 14.7785 15.5701C14.3832 15.6136 13.9335 15.3229 13.8343 14.8854C13.742 14.4806 13.727 14.058 13.6767 13.6287C13.6075 13.6369 13.545 13.6247 13.5191 13.6491C12.6116 14.5322 11.5574 15.1897 10.3605 15.5864C8.89052 16.0742 7.3961 16.1285 5.87722 15.7603C4.30265 15.3799 3.00658 14.5553 1.90342 13.4005C1.03938 12.4957 0.434816 11.4251 0.081589 10.2323C-0.0094348 9.92393 0.00279222 9.48919 0.157669 9.22156C0.547577 8.54907 1.38309 8.6496 1.70643 9.37779C2.12759 10.3288 2.4944 11.3002 3.22259 12.0881C4.6287 13.6124 6.37038 14.2102 8.40551 14.0662C10.0969 13.9466 11.4487 13.1655 12.5654 11.9292C12.6809 11.8001 12.7638 11.6412 12.8616 11.4972L12.7488 11.3953V11.398Z"
              fill="white" />
            <path
              d="M2.65351 4.52364C3.56511 4.24785 4.31504 4.01689 5.06904 3.79545C5.75783 3.59438 6.25643 3.72344 6.50776 4.15275C6.79985 4.6527 6.51591 5.2396 5.88146 5.42437C4.39655 5.85639 2.91028 6.28162 1.42537 6.70685C0.862925 6.86852 0.314065 6.53431 0.276025 5.97323C0.170057 4.40816 0.0735986 2.84309 0.0015947 1.27667C-0.0296523 0.594669 0.401013 0.23465 1.05448 0.337901C1.44847 0.400395 1.68621 0.628633 1.73376 1.03892C1.78403 1.47094 1.84381 1.90161 1.9063 2.38797C2.42935 1.99807 2.88039 1.63397 3.35861 1.30792C5.07719 0.134116 7.03081 -0.234055 9.00752 0.140909C11.9189 0.693845 14.0437 2.37575 15.1482 5.20292C15.2691 5.51267 15.3792 5.83601 15.4349 6.16342C15.5218 6.67968 15.1971 7.1511 14.7379 7.2462C14.3385 7.32907 13.8413 6.99487 13.6918 6.54111C13.412 5.69064 13.0275 4.90675 12.4528 4.19894C11.1527 2.59991 9.46535 1.92063 7.44517 1.94644C5.59073 1.96954 4.11533 2.77652 2.90077 4.1283C2.82877 4.20845 2.78529 4.3117 2.65215 4.52635L2.65351 4.52364Z"
              fill="white" />
          </svg>
        </span>
      </button>
    </div>

  </div>

  <!-- profile information and notifications -->
  <div class="col-sm-9 header-right clearfix">

    <!-- Signin information-->
    <div class="pe-5">
      <app-signin-panel *ngIf="isLTLicenseEnabled$ | async"></app-signin-panel>
    </div>
    <!-- Signin Information ends-->

    <div class="pull-right">
      <div ngbDropdown class="btn-group notificon"  (openChange)="dropdownChanged($event)">
        <span title="{{'_Shared_App_State_Notifications_Text_' | translate }}" data-toggle="dropdown" id="dropdownMenuButton3" ngbDropdownToggle>
          <button aria-haspopup="true" aria-expanded="false"><img src="assets/images/icon/bell-solid.svg"
              alt="Notifications"><span>{{alertCount}}</span></button>
        </span>
        <ul class="dropdown-menu cc-dropdown-menu alerts-container" aria-labelledby="dropdownMenuButton3"
          ngbDropdownMenu>
          <ng-container *ngIf="(bcsNotifications$ | async)?.messages &&
          (bcsNotifications$ | async)?.messages?.length !== 0">
            <li class="dropdown-item" *ngFor="let bcsNotification of (bcsNotifications$ | async)?.messages">
              <a>

                <div class="notify-text" *ngIf="bcsNotification.isMessageRead">
                  <p>{{ bcsNotification.ltsAlertDto.alertDescription }}</p>
                  <!--<span>Just now</span>-->
                </div>
                <div class="notify-text-unread d-flex" *ngIf="!(bcsNotification.isMessageRead)">
                  <i class="fas fa-solid fa-circle me-2"></i>
                  <div>
                    <p>{{ bcsNotification.ltsAlertDto.alertDescription }}</p>
                    <!--<span>Just now</span>-->
                  </div>
                </div>
              </a>
            </li>
          </ng-container>
          <ng-container *ngIf="(bcsNotifications$ | async)?.messages?.length === 0">
            <li class="dropdown-item">
              <a>
                <div class="notify-text">
                    <p>{{'_Shared_App_State_No_Alerts_Text_' | translate }}</p>
                    <a *ngIf="(isLTLicenseEnabled$ | async) && userPermissionList?.includes(27)"
                      (click)="gotoGlobalAlerts()"><span class="alerts-link">{{'_Shared_App_State_Manage_Alerts_Text_' | translate }}</span></a>
                </div>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div ngbDropdown class="btn-group">
        <span ngbDropdownToggle title="{{'_Shared_App_State_User_Settings_Text_' | translate }}" class="cc-dropdown-span" id="dropdownMenuButton4" data-toggle="dropdown">
          <button class="ellipsis cc-dropdown-button" type="button" aria-haspopup="true"
            aria-expanded="false">{{loggedUserName}}</button>
        </span>
        <ul ngbDropdownMenu class="cc-dropdown-menu" aria-labelledby="dropdownMenuButton4">
          <li class="dropdown-item" (click)="gotMyAccount()"> {{'_General_My_Account_Text_' | translate }}</li>
          <li class="dropdown-item" *ngIf="((isLTLicenseEnabled$ | async) && (userPermissionList?.includes(62)))"
            (click)="gotoMyAlerts()">{{'_General_My_Alerts_Text_' | translate }}</li>
          <li class="dropdown-divider"></li>
          <!-- <li class="dropdown-item" (click)="openSignoutPopup()">Sign Out</li> -->
          <li class="dropdown-item" (click)="logout()">{{'_Shared_App_State_LogOut_Text_' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- header area end -->

<app-tenantchange-popup *ngIf="userPermissionList?.includes(26)" [(dialogOpened)]="tenantChangeOpened"
  (cancelled)="closeTenantChange()">
</app-tenantchange-popup>

<kendo-dialog title="{{'_Shared_App_State_Sync_Data_Text_' | translate }}" *ngIf="syncConfPopupOpen" (close)="closeSyncPopup('no')" [minWidth]="250" [width]="650">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <p class="mb-2">{{'_Shared_App_State_Sync_Data_Info_Text_' | translate }}
  </p>
  <p class="mb-2">{{'_Shared_App_State_Sync_Data_Info2_Text_' | translate }}
  </p>
  <p>{{'_Shared_App_State_Sync_Data_Info3_Text_' | translate }}
  </p>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton (click)="closeSyncPopup('no')" class="btn btn-secondary">{{'_General_Action_Label_No_Text_' | translate }}</button>
    <button kendoButton (click)="closeSyncPopup('yes')" class="btn btn-primary">{{'_General_Action_Label_Yes_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="{{'_Shared_App_State_Validation_Error_Text_' | translate }}" *ngIf="showSyncValidationResultPopup"
  (close)="closeSyncValidationResultPopup()" [minWidth]="250" [width]="800">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="manual-sync">
    <p class="mb-3">{{'_Shared_App_State_Validation_Error_Info_Text_' | translate }}
    </p>
    <div class="mb-3 error-section" *ngFor="let err of validationErrorList">
      <h5>{{err.resource}}</h5>
      <ul class="ms-2">
        <li *ngFor="let eo of err.errorObjs">
          <h6>{{eo.id}}</h6>
          <div class="d-flex" *ngFor="let e of eo.errors; let indexOfelement=index;">
            <span class="error-num">{{indexOfelement+1}}.</span>
            <span class="sync-error">{{e}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton (click)="closeSyncValidationResultPopup()" class="btn btn-secondary">{{'_General_Button_Close_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
